import React from 'react';
import './Quotes.css';

const Quotes = () => (
  <section className="quote">
    <h1>
      “Mathematics is not about numbers, equations, computations,
      or algorithms: it is about understanding.”

      - William Paul Thurston.

    </h1>
  </section>
);

export default Quotes;
